import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as SitemapSvg } from './assets/sitemap.svg';

const SitemapIcon = React.forwardRef((args, ref) => <SvgIcon component={SitemapSvg} ref={ref} {...args} />);

export default SitemapIcon;
